import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useTestState } from '../context/TestContext';

const ProgressBar = () => {
  const { pathname } = useLocation();
  const { state } = useTestState();

  const { t } = useTranslation('progressBar');

  const steps = [
    t('setup'),
    t('training'),
    t('right-ear'),
    t('left-ear'),
    t('results'),
  ];

  const getWidth = (i: number) =>
    `${state.currentStep > i ? '100' : state.currentStep < i ? '0' : state.progress}%`;

  if (pathname !== '/' && pathname !== '/results/detailedresults') {
    return (
      <div className="progress-bar">
        {steps.map((stepName, i) => (
          <div className="progress-bar-step" key={`progress-step-${i}`}>
            <p>{stepName}</p>
            <div
              className="progress-bar-background-color"
              style={{
                width: getWidth(i),
                transition: 'width 0.8s ease-in-out',
              }}
            />
          </div>
        ))}
      </div>
    );
  } else {
    return <></>;
  }
};

export default ProgressBar;
